<template>
  <v-container class="mt-4 pa-0">
    <v-card class="elevation-1 primary" :style="{height: '85vh', overflow: 'scroll'}">
      <v-toolbar color="primary" flat>
        <v-tooltip bottom>
          <v-toolbar-side-icon @click="getAllExceptions(searchParams)" slot="activator" icon>
            <v-icon>refresh</v-icon>
          </v-toolbar-side-icon>
          <span>Refresh exception list</span>
        </v-tooltip>
        <v-toolbar-title class="hidden-xs-only">
          <h3>Exceptions ({{ exceptions.totalItems || 0 }})</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout row wrap>
          <v-flex class="text-xs-right" xs12 sm8 offset-sm4>
            <v-select
              v-model="filterStatus"
              :items="statuses"
              item-text="text"
              item-value="value"
              label="Filter By Status"
              color="secondary"
              class="mx-1"
              hide-details
              box
            ></v-select>
          </v-flex>
        </v-layout>
      </v-toolbar>

      <v-data-table
        class="primary mx-4"
        :headers="headers"
        :total-items="exceptions.totalItems"
        :items="exceptionsModel"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props" :style="{color: 'red'}">
          <tr
            @click="['waiting', 'investigation'].includes(props.item.state) ? showException(props.item._id) : ''"
          >
            <td class="text-xs-left">{{ props.item.location[1] }}</td>
            <td class="text-xs-left" :style="{width: '25vw'}">{{ props.item.product[1] }}</td>
            <td class="text-xs-left">{{ localizeDate(props.item.createDate) }}</td>
            <td class="text-xs-left">{{ props.item.enteredValue }}</td>
            <td class="text-xs-left">{{ props.item.correctValue }}</td>
            <td class="text-xs-left">{{ props.item.evalBy }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";

export default {
  name: "InventoryExceptions",

  data() {
    return {
      headers: [
        { text: "Location", value: "location[1]" },
        { text: "Product", value: "product[1]", sortable: false },
        { text: "Evaluation Date", value: "createDate", sortable: true },
        { text: "Evaluated Quantity", value: "enteredValue", sortable: false },
        { text: "Quantity in System", value: "correctValue", sortable: false },
        { text: "User", value: "evalBy", sortable: false }
      ],
      pagination: {
        rowsPerPage: 10,
        sortBy: "createDate",
        descending: true,
        page: 1
      },
      filterStatus: "waiting",
      statuses: [
        { text: "Unresolved - Waiting", value: "waiting" },
        { text: "Unresolved - Under Investigation", value: "investigation" },
        { text: "Resolved - Incorrect Count", value: "incorrect" },
        { text: "Resolved - Adjustment Made", value: "adjustment" },
        { text: "Correct Count", value: "correct" }
      ]
    };
  },

  mixins: [LoginCheck, Common],

  async beforeMount() {
    this.getAllExceptions(this.searchParams);
  },

  computed: {
    ...mapGetters({
      exceptions: "inventory/getAllExceptions"
    }),

    exceptionsModel() {
      if (this.exceptions.docs)
        return this.exceptions.docs.filter(item => {
          return item;
        });
    },
    searchParams() {
      return {
        ...this.pagination,
        search: this.search || null,
        from: this.fromDate || null,
        to: this.toDate || null,
        type: this.filterStatus || null
      };
    }
  },

  watch: {
    filterStatus() {
      this.getAllExceptions(this.searchParams);
    },

    pagination: {
      handler() {
        this.getAllExceptions(this.searchParams);
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      getAllExceptions: "inventory/getExceptions"
    }),

    showException(id) {
      this.$router.push(`/inventory/exceptions/${id}`);
    },

    stateText(state) {
      return this.statuses.filter(item => {
        if (item.value == state) return item;
      })[0].text;
    }
  }
};
</script>

<style scoped>
>>> .v-table.theme--dark tr:hover {
  cursor: pointer;
}
>>> table.v-table th {
  font-size: 15px !important;
}
>>> table.v-table tbody td {
  font-size: 15px !important;
}
</style>